import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
  state: () => ({
    toast: '',
    toastType: 'error'
  }),
  actions: {
    showToast(message, type = 'error') {
      this.toast = message || ''
      this.toastType = type
      if (this.toast) {
        clearTimeout(this._toastTimer)
        this._toastTimer = setTimeout(() => {
          this.toast = ''
        }, 4000)
      }
    }
  }
})
